 $('.filter-group select').on('change', function() {
      var show_class = '';
      $('.filter-group select').each(function() {
        if ($(this).val()) {
          show_class += '.' + 'filter-' + $(this).val();
        }
      });
      if (show_class) {
        $('.product-item').addClass('hidden');
        $('.product-item' + show_class).removeClass('hidden');
      } else {
        $('.product-item').removeClass('hidden');
      }
      $('.clear-filter').removeClass('hidden');
      $('.no-products').addClass('hidden');
      if ($('.product-item').length == $('.product-item.hidden').length) {
        $('.no-products').removeClass('hidden');
      }
    });
    $('.clear-filter').on('click', function(){
      $('.no-products').addClass('hidden');
      $('.clear-filter').addClass('hidden');
      $('.product-item').removeClass('hidden');
      $('.filter-group select').val('');
    });